<div class="d-flex flex-column align-items-center card">
  <img src="assets/images/error.png" alt="done" width="48" height="48" />

  <h2 class="semi-bold mt-6 text-align-center">Sorry! Time's up to add protection</h2>

  @let error = errorService.error$ | async;
  @if (error) {
    <p class="mt-3 text-align-center">{{ error }}</p>
  }
</div>
